import {
  FETCH_CATEGORY,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_ERROR,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_ERROR,
  ADD_CATEGORY,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_ERROR,
  RESET_UPDATE_CATEGORY,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  updating: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CATEGORY: {
      return {...state, error: '', loading: true, payload: {}};
    }
    case ADD_CATEGORY: {
      return {...state, error: '', updating: true};
    }
    case UPDATE_CATEGORY: {
      return {...state, error: '', updating: true};
    }
    case FETCH_CATEGORY_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case ADD_CATEGORY_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case UPDATE_CATEGORY_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }};
    }
    case FETCH_CATEGORY_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_CATEGORY_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case UPDATE_CATEGORY_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_UPDATE_CATEGORY: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
